export default abstract class Transformer<T, TT> {
  private _plugins: Transformer<TT, TT>[] = [];
  public set plugins(plugins: Transformer<TT, TT>[]) {
    this._plugins = plugins;
  }

  constructor(plugins: Transformer<TT, TT>[] = []) {
    this._plugins = plugins;
  }

  protected abstract _transform(data: T): TT;

  public transform(data: T): TT {
    let transformed = this._transform(data);
    for (const plugin of this._plugins) {
      transformed = plugin.transform(transformed);
    }
    return transformed;
  }
}
